import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-8" }
const _hoisted_2 = { class: "font-weight-bold mb-2" }
const _hoisted_3 = { class: "sub-title-2 mb-4 pr-6" }
const _hoisted_4 = { class: "d-flex flex-column flex-md-row justify-space-around" }
const _hoisted_5 = { class: "flex-shrink-0 mr-4" }

import maropostLogoUrl from '@/assets/maropost-logo.svg'
import { EXPLORE_MORE_PRODUCTS } from '@/constants/productExplore.constants'

// --------------------------------------------------
// Data
// --------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductExplore',
  setup(__props) {


// --------------------------------------------------
// Imports
// --------------------------------------------------
const exploreMore = EXPLORE_MORE_PRODUCTS

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("header", { class: "my-4" }, [
      _createElementVNode("h4", { class: "font-weight-bold" }, "Explore more from Maropost ")
    ], -1)),
    _createVNode(_component_v_container, {
      class: "px-0 mb-12",
      fluid: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exploreMore), (explore) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                cols: "12",
                md: "6",
                lg: "4",
                key: explore.title
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "service-card",
                    flat: "",
                    elevation: 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "text-left pa-2 pb-12 card-bg" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            "max-width": 80,
                            contain: "",
                            src: _unref(maropostLogoUrl),
                            class: "mr-3 pt-5"
                          }, null, 8, ["src"]),
                          _createElementVNode("h2", _hoisted_2, _toDisplayString(explore.title), 1),
                          _createVNode(_component_v_divider, { class: "mb-4" }),
                          _createElementVNode("p", _hoisted_3, _toDisplayString(explore.description), 1),
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_v_img, {
                                src: explore.image,
                                alt: `${explore.title} illustration`,
                                width: "157",
                                height: "120",
                                class: "mr-2"
                              }, null, 8, ["src", "alt"])
                            ]),
                            _createVNode(_component_v_list, {
                              density: "compact",
                              class: "text-left",
                              style: {"background":"transparent"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explore.features, (feature, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: `${explore.title}-${index}`,
                                    class: "pa-0 mb-1",
                                    "min-height": 28
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        size: "x-small",
                                        color: "#545C6C",
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                          _createTextVNode(" mdi-circle ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(feature.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                _createVNode(_component_v_list_item, { class: "px-0 mt-5" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      href: explore.action.link,
                                      target: "_blank",
                                      "base-color": "black",
                                      class: "font-weight-bold text-none",
                                      variant: "elevated"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(explore.action.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["href"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})